import { selectorsTypes } from "../settings/types";

const initialState = {
     supervisors: [],
 }

 const selectorsReducer = (state = initialState, action) => {
    switch (action.type){
        case selectorsTypes.registerSupervisors:
            return { ...state, supervisors: action.payload }

        case selectorsTypes.addSupervisors: {
            const resultList = state.supervisors.slice()
            resultList.unshift(action.payload)

            return { ...state, supervisors: resultList }
        }

        case selectorsTypes.removeSupervisors: {
            const resultList = state.supervisors.map( item => {
                if(item?.id != action?.payload)
                    return item
            })

            return { ...state, supervisors: resultList}
        }

        case selectorsTypes.clearSupervisors:
            return { ...state, supervisors: [] }
        default:
            return state
    }
 }

 export default selectorsReducer